import React, { useState, useContext } from "react";
import "./UpdatePassword.css";
import { TbLock } from "react-icons/tb";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useLanguage } from "../../../LanguageProvider";
import Services from "../../../services/Services";
import { GeneralContext } from "../../../GeneralProvider";
import { useToaster } from "../../../ToasterProvider";

export default function UpdatePassword() {
  const { getTranslation } = useLanguage();
  const { toastError, toastSuccess, toastWarning } = useToaster();
  const { userId, useToken } = useContext(GeneralContext);

  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  const handleChangePassword = () => {
    if (!password.trim() || !newPassword.trim()) {
      toastError(getTranslation("passwordCannotBeEmpty"));
      return;
    }

    let userData = null;
    if (sessionStorage.getItem("user")) {
      userData = JSON.parse(sessionStorage.getItem("user"));
    } else if (localStorage.getItem("user")) {
      userData = JSON.parse(localStorage.getItem("user"));
    }

    if (!userData || !userData.email) {
      toastError(getTranslation("somethingWentWrong"));
      return;
    }

    const email = userData.email;

    Services.UserLogin(useToken, email, password)
      .then((res) => {
        if (res.data.status) {
          Services.UpdateUserPassword(useToken, userId, newPassword)
            .then((res) => {
              if (res.data.status) {
                toastSuccess(getTranslation("successMessage"));
                setPassword("");
                setNewPassword("");
              } else {
                toastError(getTranslation("passwordCriteriaNotMet"));
              }
            })
            .catch((err) => {
              console.error(err);
              toastError(getTranslation("somethingWentWrong"));
            });
        } else {
          toastError(getTranslation("invalidPassword"));
        }
      })
      .catch((err) => {
        console.error(err);
        toastError(getTranslation("somethingWentWrong"));
      });
  };

  return (
    <div className="update-password-main-content">
      <div className="update-password-right-content">
        <div className="update-password-title">
          {getTranslation("changePassword")}
        </div>
        <div className="update-password-subtitle">
          {getTranslation("changeYourPassword")}
        </div>
        <div className="update-password-profile-input-container">
          <label className="update-password-label">
            {getTranslation("password")}
          </label>
          <div className="update-password-input-container">
            <input
              className="update-password-input"
              type={showPassword ? "text" : "password"}
              id="password"
              placeholder={getTranslation("password")}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <span
              className="update-password-password-toggle"
              onClick={() => setShowPassword((p) => !p)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <label className="update-password-label">
            {getTranslation("newPassword")}
          </label>
          <div className="update-password-input-container">
            <input
              className="update-password-input"
              type={showNewPassword ? "text" : "password"}
              id="newPassword"
              placeholder={getTranslation("newPassword")}
              value={newPassword}
              onChange={(e) =>
                setNewPassword(e.target.value.replace(/\s/g, ""))
              }
              onKeyDown={(e) => {
                if (e.key === " ") {
                  e.preventDefault();
                  toastWarning(getTranslation("passwordCannotContainSpaces"));
                }
              }}
            />
            <span
              className="update-password-password-toggle"
              onClick={() => setShowNewPassword((p) => !p)}
            >
              {showNewPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <div
            style={{
              textAlign: "left",
              fontSize: "14px",
              flexDirection: "row",
              display: "flex",
              gap: "15px",
              marginTop: "15px",
            }}
          >
            <div>
              <p
                style={{
                  color: newPassword.length >= 8 ? "#60b85a" : "#4d5885",
                  margin: "4px 0",
                }}
              >
                • At least 8 characters
              </p>
              <p
                style={{
                  color: /[^A-Za-z0-9ÇÖÜĞŞİçöüğşı]/.test(newPassword)
                    ? "#60b85a"
                    : "#4d5885",
                  margin: "4px 0",
                }}
              >
                • At least 1 special character
              </p>
              <p
                style={{
                  color: /\d/.test(newPassword) ? "#60b85a" : "#4d5885",
                  margin: "4px 0",
                }}
              >
                • At least 1 number
              </p>
            </div>
            <div>
              <p
                style={{
                  color: /[A-ZÇĞİÖŞÜ]/.test(newPassword)
                    ? "#60b85a"
                    : "#4d5885",
                  margin: "4px 0",
                }}
              >
                • At least 1 uppercase letter
              </p>
              <p
                style={{
                  color: /[a-zçğıöşü]/.test(newPassword)
                    ? "#60b85a"
                    : "#4d5885",
                  margin: "4px 0",
                }}
              >
                • At least 1 lowercase letter
              </p>
            </div>
          </div>
        </div>
        <button
          className="update-password-button"
          onClick={handleChangePassword}
        >
          {getTranslation("update")}
        </button>
      </div>
    </div>
  );
}
